import React, { useEffect, useState } from "react";

const BackgroundImage = ({ imageUrl, position, size }) => {
    return (
        <div
            className="absolute inset-0 bg-no-repeat z-0"
            style={{
                backgroundImage: `url("${imageUrl}")`,
                backgroundPosition: position,
                backgroundSize: size,
                zIndex: 0,
            }}
        />
    );
};

const Files = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const position = windowWidth > 1024 ? "90% 80px" : 'center 190%';
    const size = windowWidth > 1024 ? "250px" : '270px';
    return (
        <div className="px-2 py-20 w-full flex flex-col sm:flex-row gap-12 justify-between relative">
            <div className="bg-[#353A40] flex gap-4 flex-col p-8 rounded-2xl w-full lg:w-[48%] lg:justify-center min-h-80 lg:min-h-56 relative">
                <BackgroundImage
                    imageUrl="https://www.figma.com/file/XhZzAqgkD6oylY0rSfufoE/image/b8aca9913f042541a317a459b317878100d0413a"
                    position={position}
                    size={size}

                />
                <span className="text-white w-[80%] lg:w-[60%] flex text-wrap text-base lg:text-2xl">Мы гарантируем результат, работая по договору</span>
                <a href="public/docs/Договор экспедирования ЮЛА.pdf" download="public/docs/Договор экспедирования ЮЛА.pdf" className="px-4 py-2 bg-white w-fit flex flex-row gap-4 rounded-full z-10" >
                    <span className="text-nowrap flex text-xs items-center">Скачать договор</span>
                    <img className="h-4 w-[9%] my-auto" src="/download-red.png" alt="Download" />
                </a>
            </div>


            <div className="bg-[#C3372E] flex gap-4 flex-col p-8 rounded-2xl w-full lg:w-[48%] lg:justify-center min-h-80 lg:min-h-56 relative">
                <BackgroundImage
                    imageUrl="https://www.figma.com/file/XhZzAqgkD6oylY0rSfufoE/image/fada396d10cf602dc94646338689ff30bc6e2f97"
                    position={position}
                    size={size}
                />
                <span className="text-white w-[80%] lg:w-[60%] flex text-wrap text-base lg:text-2xl z-10">Подготовим нужные  документы при необходимости </span>
                <a href="public/docs/Соглашение об обработке персональных данных.pdf" download="./docs/Соглашение об обработке персональных данных.pdf" className="px-4 py-2 bg-white w-fit flex flex-row gap-4 rounded-full z-10">
                    <span className="text-nowrap flex text-xs items-center">Скачать накладную ТОРГ 12</span>
                    <img className="h-4 w-[9%] my-auto" src="/download-red.png" alt="Download" />
                </a>
            </div>
        </div>
    )
}

export default Files